import { render, staticRenderFns } from "./UploadCloud02Icon.vue?vue&type=template&id=823d3c12"
import script from "./UploadCloud02Icon.vue?vue&type=script&lang=js"
export * from "./UploadCloud02Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports